const brands = [
  'BRASILGAS',
  'CONSIGAZ',
  'COPAGAZ',
  'LIQUIGAS',
  'NACIONALGAS',
  'SERVGAS',
  'SUPERGASBRAS',
  'ULTRAGAZ',
];

export default brands;



// WEBPACK FOOTER //
// ../utils/constants/brands.js